/**
 * OpenTelemetry Constants
 *
 * Centralized constants for OTel configuration and span names.
 * All span names follow kebab-case convention: {action}-{resource}
 */

/**
 * Service identification
 */
export const OTEL_SERVICE_NAME = 'quote-frontend';

/**
 * Span names for distributed tracing
 * Organized by feature domain for easy navigation
 */
export const SPAN_CREATE_BASKET = 'create-basket';
export const SPAN_REFETCH_BASKET = 'refetch-basket';
export const SPAN_REMOTE_BASKET_UPDATE = 'remote-basket-update';

export const SPAN_SELECT_INSURANCE = 'select-insurance-quote';
export const SPAN_DESELECT_INSURANCE = 'deselect-insurance-quote';

export const SPAN_ADD_MOBILE_SIM = 'add-mobile-sim';
export const SPAN_EDIT_MOBILE_SIM = 'edit-mobile-sim';
export const SPAN_UPDATE_MOBILE_REQUIREMENTS = 'update-mobile-requirements';
export const SPAN_REMOVE_MOBILE_SIM = 'remove-mobile-sim';
export const SPAN_REMOVE_MOBILE_SERVICE = 'remove-mobile-service';

export const SPAN_SELECT_ENERGY_TARIFF = 'select-energy-tariff';
export const SPAN_UPDATE_ENERGY_TARIFF = 'update-energy-tariff';
export const SPAN_UPDATE_EV_INTEREST = 'update-ev-interest';
export const SPAN_SUBMIT_ENERGY_DETAILS = 'submit-energy-details';

export const SPAN_SUBMIT_BROADBAND = 'submit-broadband';
export const SPAN_REMOVE_BROADBAND = 'remove-broadband';

export const SPAN_SELECT_CASHBACK = 'select-cashback-card';
export const SPAN_REMOVE_CASHBACK = 'remove-cashback-card';

export const SPAN_SUBMIT_APPLICATION = 'submit-application';

export const SPAN_SAVE_FOR_LATER = 'save-quote-for-later';

export const SPAN_SEARCH_ADDRESS = 'search-address';

export const SPAN_PAGE_LOAD = 'page-load';
